import React, { Dispatch, SetStateAction } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import styled from "@emotion/styled";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import BasicButton from "@components/button/BasicButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const SwiperContainer = styled(Swiper)(({ theme }) => ({
  position: "relative",
  maxWidth: "560px",
  width: "100%",
  height: "100dvh",
  maxHeight: "100dvh",

  ".swiper-pagination": {
    bottom: "2rem",
  },
  ".swiper-pagination-bullet": {
    width: "115px",
    height: "2px",
    backgroundColor: theme.color.white,
    borderRadius: "0",
  },
  ".swiper-pagination-bullet-active": {
    backgroundColor: theme.color.black,
  },
}));

const FirstTab = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  height: "100dvh",
  backgroundImage: `url(${theme.image.sub_bg_1.default})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  color: theme.color.white,

  ".title": {
    fontSize: "2.8rem",
    fontWeight: theme.fontWeight.bold,
  },

  ".desc": {
    color: theme.color.light_gray,
  },

  ".last": {
    paddingBottom: "8.8rem",
  },
}));

const FirstTabHeader = styled.div(({ theme }) => ({
  padding: "1.6rem 1.4rem",
  alignSelf: "flex-start",
}));

const FlexBox = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "2.4rem",
  alignItems: "center",
  justifyContent: "center",
});
const TextBox = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "0.2rem",
  alignItems: "center",
  justifyContent: "center",
});

const SecondTab = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  height: "100dvh",
  backgroundImage: `url(${theme.image.sub_bg_2.default})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  color: theme.color.white,

  ".title": {
    fontSize: "2.8rem",
    fontWeight: theme.fontWeight.bold,
  },

  ".desc": {
    color: theme.color.light_gray,
  },

  ".last": {
    paddingBottom: "8.8rem",
  },
}));

const SecondSlideTopWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2.4rem",
  alignItems: "center",
  width: "100%",

  ".title": {
    color: theme.color.white,
    fontWeight: theme.fontWeight.light,
    lineHeight: "2rem",
    letterSpacing: "3.2px",
    fontSize: "1.6rem",
  },
}));

const SecondSlideHeader = styled.div(({ theme }) => ({
  padding: "1.6rem 1.4rem",
  alignSelf: "flex-end",
}));

const SecondSlideContent = styled.div(({ theme }) => ({
  width: "100%",
  padding: "0 2rem 8.8rem",
}));

type Props = {
  tab: number;
  setTab: Dispatch<SetStateAction<number>>;
};

const SubscribeSwiper = ({ tab, setTab }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handlePrev = () => {
    setTab(0);
  };

  const handleMyPage = () => {
    navigate("/my-page");
  };

  const handleSubscribe = () => {
    console.log("결제연동");
  };

  return (
    <SwiperContainer
      modules={[Pagination]}
      slidesPerView={1}
      centeredSlides={false}
      pagination={{ clickable: false }}>
      <SwiperSlide>
        <FirstTab>
          <FirstTabHeader>
            <button onClick={handlePrev}>
              <Image src={theme.image.arrow_left_white.default} />
            </button>
          </FirstTabHeader>

          <FlexBox>
            <span className="title">동대문 도매 이월상품</span>
            <TextBox>
              <span className="desc">SHAKALAKA 멤버쉽 회원은</span>
              <span className="desc">
                유통마진 및 수수료가 포함되지 않은 도매가격 그대로
              </span>
              <span className="desc">쇼핑할 수 있습니다.</span>
            </TextBox>
          </FlexBox>

          <FlexBox className="last">
            <span className="desc">* 새 상품인 경우에만 50%적용 가능</span>
            <TextBox>
              <span className="desc">* 세컨핸드 상품 구매 시,</span>
              <span className="desc">
                셀러가 정한 판매가격으로 구입이 가능합니다.
              </span>
            </TextBox>
          </FlexBox>
        </FirstTab>
      </SwiperSlide>

      <SwiperSlide>
        <SecondTab>
          <SecondSlideTopWrapper>
            <SecondSlideHeader>
              <button onClick={handleMyPage}>
                <Image src={theme.image.close_white.default} />
              </button>
            </SecondSlideHeader>

            <FlexBox>
              <Image
                src={theme.image.logo_white.default}
                width="24rem"
                height="2.4rem"
              />
              <span className="title">{t("샤카라카")}</span>
            </FlexBox>
          </SecondSlideTopWrapper>

          <SecondSlideContent>
            <BasicButton
              title="월 5,500원 구독하기"
              point
              big
              onClick={handleSubscribe}
            />
          </SecondSlideContent>
        </SecondTab>
      </SwiperSlide>
    </SwiperContainer>
  );
};

export default SubscribeSwiper;
